import paths from '@/paths';
import type { ContentWrapperDto, CountryDto, ContentDto } from '@/types/content';

/**
 * Shared building blocks for the header primary navigation (Destinations / Experiences / Tours).
 * Used by both the desktop hover mega-menus and the mobile full-screen nav so the two stay in sync.
 */

/** One shared box model for button triggers + Tours link so they sit on one line, same baseline. */
export const navTopItemClass =
  'inline-flex shrink-0 items-center justify-center font-inter text-sm font-medium leading-none whitespace-nowrap';

export const toursLinkClass = `${navTopItemClass} text-gray-200 transition-colors hover:text-primary-400`;

export const triggerClass = (active: boolean) =>
  [
    navTopItemClass,
    'cursor-pointer appearance-none border-0 bg-transparent p-0 transition-colors',
    active ? 'text-primary-400' : 'text-gray-200 hover:text-primary-400',
  ].join(' ');

/** Names hidden from the public navigation (kept identical across desktop + mobile). */
const HIDDEN_EXPERIENCE_NAMES = new Set(['horseback safari']);
const HIDDEN_DESTINATION_NAMES = new Set(['botswana']);

export function getVisibleExperiences(content: ContentWrapperDto | null): ContentDto[] {
  return (content?.experiences ?? [])
    .map((experience) => {
      if (experience.slug.trim().toLowerCase() === 'herping') {
        return { ...experience, name: 'Frogs & Amphibians', slug: 'frogs-amphibians' };
      }
      return experience;
    })
    .filter(
      (experience) => !HIDDEN_EXPERIENCE_NAMES.has(experience.name.trim().toLowerCase())
    );
}

export function filterVisibleCountries(countries: CountryDto[] | undefined): CountryDto[] {
  return (countries ?? []).filter(
    (country) => !HIDDEN_DESTINATION_NAMES.has(country.name.trim().toLowerCase())
  );
}

export function countryHref(country: CountryDto): string {
  const slug = (country.slug || '').trim();
  if (slug) return paths.destinationCountry(slug);
  return paths.destinationCountry(String(country.id));
}
